<template>
    <div>
        <loading v-if="loading" :size="2" message="Обновляем пароль..."></loading>
        <form v-else class="form-horizontal" @submit.prevent="beforeSubmit">
            <div class="form-group row" v-if="!currentUser.isAdmin">
                <label for="old-password" class="col-4 col-md-2 col-form-label">Старый пароль</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" name="firstname" type="password" id="old-password" v-model="oldPassword">
                </div>
                <div class="help-inline col-12 col-md-6">
                    <small class="text-muted">Если вы не помните старый пароль, то обратитесь к администратору, или сбросте пароль через email</small>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.newPassword.$error }">
                <label for="new-password" class="col-4 col-lg-2 col-form-label">Новый пароль</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" name="firstname" type="password" id="new-password" v-model="newPassword" @input="$v.newPassword.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newPassword.$error">Новый пароль должен быть не менее 6 символов</span>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.remindNewPassword.$error }">
                <label for="remind-new-password" class="col-4 col-lg-2 col-form-label">Повторите новый пароль</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" name="firstname" type="password" id="remind-new-password" v-model="remindNewPassword" @input="$v.remindNewPassword.$touch()">
                    <span class="small help-block text-danger" v-if="$v.remindNewPassword.$error">Пароли должны совпадать</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="offset-sm-2 col-sm-10">
                    <button type="submit"  :class="{ 'disabled': $v.remindNewPassword.$invalid }" :disabled="$v.remindNewPassword.$invalid"  class="btn btn-primary">Сохранить</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import changePasswordMutation from './../../gql/mutations/ChangePassword.graphql'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import { required, minLength, sameAs } from 'vuelidate/lib/validators'
  export default {
    computed: mapState({
      user: state => state.userStore.user,
      currentUser: state => state.globalStore.user
    }),
    data () {
      return {
        loading: false,
        oldPassword: null,
        newPassword: null,
        remindNewPassword: null
      }
    },
    methods: {
      /**
       * todo добавить валидацию
       */
      beforeSubmit () {
        this.changePassword()
      },
      changePassword () {
        this.loading = true
        this.$apollo.mutate({
          mutation: changePasswordMutation,
          variables: {
            userId: this.user.id,
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
            remindNewPassword: this.remindNewPassword
          }
        }).then((data) => {
          this.loading = false
          this.oldPassword = null
          this.newPassword = null
          this.remindNewPassword = null
          this.$v.newPassword.$reset()
          this.$v.remindNewPassword.$reset()
          this.addToast({
            text: 'Пароль успешно обновлен',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка при обновлении пароля: ' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    validations: {
      newPassword: {
        required,
        minLength: minLength(6)
      },
      remindNewPassword: {
        sameAsPassword: sameAs('newPassword')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Security.vue?770e3ce7